import { render, staticRenderFns } from "./FormSubtopic.vue?vue&type=template&id=04cd45e8&"
import script from "./FormSubtopic.vue?vue&type=script&lang=js&"
export * from "./FormSubtopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports